import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import {FormControlLabel} from 'material-ui/Form';

export const InputFieldCheckbox = (props) => {
    const {checked, onChange, name} = props;

    return (
        <div className="checkbox">
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={(event) => {
                            onChange(event.target.checked);
                        }}
                        name={name}
                    />
                }
                label={name}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_single_checkbox.js